import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Badge.css';

const Badge = ({ color = 'gray', className, children }) => (
    <div style={{ color }} className={classNames(css.badge, className)}>
        {children}
    </div>
);

Badge.propTypes = {
    color: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Badge;
